import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'
import API_URL from "../../ApiUrl/ApiUrl";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const CarList = () => {
  const [cars, setCars] = useState([]);

  useEffect(() => {
   
    const fetchCars = async () => {
      try {
        const response = await axios.get(`${API_URL}/cars`);
        
        const newData= response.data
        const offercar=newData.filter((item)=>item.offer===false)
   
        setCars(offercar);
      } catch (error) {
        console.error('Error fetching cars:', error);
      }
    };

    fetchCars();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this car?')) {
      try {
        const response = await axios.delete(`${API_URL}/car/${id}`);
        console.log('Delete response:', response);
        setCars(cars.filter((car) => car._id !== id));
        
        toast.error("Car Delete Successfully !",{
          position:"top-center"
        })
      } catch (error) {
        console.error('Error deleting car:', error);
        alert('Failed to delete car.');
      }
    }
  };

  return (
    <div>
      <ToastContainer/>
       <div className="content-wrapper pb-2 mb-0">
  <div className="content-header">
    <div className="container-fluid">
      <div className="row mb-2">
        <div className="col-sm-6">
          <h3 className="m-0 text-dark"> Car List</h3>
        </div>
        {/* /.col */}
        <div className="col-sm-6">
          <ol className="breadcrumb float-sm-right">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">Car List</li>
          </ol>
        </div>
        {/* /.col */}
      </div>
      {/* /.row */}
    </div>
    {/* /.container-fluid */}
  </div>

  {/* Main content */}
  <section className="content">
  <div className="container-fluid">
      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table
              id="driverslisttbl"
              className="table card-table table-vcenter text-nowrap"
            >
              <thead>
                <tr>
                  <th className="w-1">S.No</th>
                  <th>Image</th>
                  <th>Name</th>
                  <th>Price</th>
                  <th>Year</th>
                  <th>Make</th>
                  <th>Model</th>
                  <th>Seats</th>
                  <th>Doors</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {cars.length > 0 ? (
                  cars.map((car, index) => (
                    <tr key={car._id}>
                      <td>{index + 1}</td>
                      <td>
                        <img
                          className="img-fluid"
                          style={{ width: 58 }}
                          src={car.images[0]} // Use the first image in the array
                          alt={car.carName}
                        />
                      </td>
                      <td>{car.carName}</td>
                      <td>{car.carPrice}</td>
                      <td>{car.year}</td>
                      <td>{car.make}</td>
                      <td>{car.model}</td>
                      <td>{car.seats}</td>
                      <td>{car.doors}</td>
                      <td>
                       
                      
                        <a
                          className="icon text-danger"
                          onClick={() => handleDelete(car._id)}
                        >
                          <i className="fa fa-trash" />
                        </a>  |
                        <a className="icon">
                          <i className="fa fa-edit" />
                        </a>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center">
                      No cars available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>

  {/* pagination */}
  <nav aria-label="Page navigation example">
  <ul className="pagination mt-4 float-end">
    <li className="page-item">
      <a className="page-link" href="#">
        Previous
      </a>
    </li>
    <li className="page-item">
      <a className="page-link" href="#">
        1
      </a>
    </li>
    <li className="page-item">
      <a className="page-link" href="#">
        2
      </a>
    </li>
    <li className="page-item">
      <a className="page-link" href="#">
        3
      </a>
    </li>
    <li className="page-item">
      <a className="page-link" href="#">
        Next
      </a>
    </li>
  </ul>
</nav>
    </div>
    </div>
  )
}

export default CarList
